export var CustomerAccountRole;
(function (CustomerAccountRole) {
    CustomerAccountRole["Primary"] = "Primary";
    CustomerAccountRole["AuthorizedUser"] = "Authorized User";
    CustomerAccountRole["AccountManager"] = "Account Manager";
    CustomerAccountRole["NonFinancialUser"] = "Non Financial User";
})(CustomerAccountRole || (CustomerAccountRole = {}));
export var AccountUseType;
(function (AccountUseType) {
    AccountUseType["Personal"] = "Personal";
    AccountUseType["Business"] = "Business";
})(AccountUseType || (AccountUseType = {}));
export var TravelProductEnum;
(function (TravelProductEnum) {
    TravelProductEnum["Hotels"] = "Hotels";
    TravelProductEnum["Cars"] = "Cars";
    TravelProductEnum["Flights"] = "Flights";
    TravelProductEnum["PremierCollection"] = "PremierCollection";
    TravelProductEnum["Homes"] = "Homes";
    TravelProductEnum["LifestyleCollection"] = "LifestyleCollection";
    TravelProductEnum["Packages"] = "Packages";
    TravelProductEnum["Experiences"] = "Experiences";
})(TravelProductEnum || (TravelProductEnum = {}));
export var cardsToShowWithPriorityOnRewardsBanner = [
    "Venture X",
    "Venture",
    "VentureOne",
    "Spark Classic Miles",
    "Spark Miles",
    "Spark Miles Select",
    "Quicksilver",
    "QuicksilverOne",
    "Quicksilver Secured",
    "Savor",
    "SavorOne",
    "Platinum",
    "Secured",
    "Journey",
    "Spark Cash",
    "Spark Cash",
    "Spark Cash Plus",
    "Spark Cash Select",
    "Spark Classic",
    "Spark Pro",
    "Walmart Rewards Card",
    "Capital One Walmart Rewards Card",
    "Capital One Walmart Rewards Plus Card",
    "Spark Pro charge card",
    "Starter",
    "Spark Cash Preferred",
    "Spark Business",
    "Capital One Cash",
].map(function (card) { return card.toLowerCase(); });
export var cardsToShowLastFourOnRewardsBanner = [
    "Capital One Miles",
    "Spark Business",
    "Capital One Small Business Card",
    "Card",
].map(function (card) { return card.toLowerCase(); });
//# sourceMappingURL=rewards.js.map